module.exports = __webpack_public_path__ + "static/educators-a0904b5da25691fbdcdb9b0b19d6604d.png";